/**
 * The page-title (h1) look shared by every owner-portal screen. Dokumente is
 * the reference: 24px, semibold, tight tracking, default foreground colour.
 *
 * Kept as one constant so a page that renders its own heading (Analytics,
 * My properties, Settings, the property/apartment/room details) cannot drift
 * from the pages that get it through AdminV2Layout — they had: bold vs
 * semibold, text-3xl vs text-2xl, a hard-coded gray-900.
 */
export const PAGE_TITLE_CLASS = "text-2xl font-semibold tracking-tight";
